import React, { useState, useEffect } from 'react';
//import Calendar from './calendar';
import '../../../../css/calendar.css';
import ScheduleCall from './scheduleCall';
import AttachFile from './attachFile';
import Calendar2 from './calendar2';
import { useSelector } from 'react-redux';


function LeadTopBarButton({newEvent, title, handleSetScripting, setApptSet, qualifier, newEventPackage, defaultCalendar, setEvent, newAppt, setNewAppt, update}) {
    const [isOpen, setIsOpen] = useState(false);
    const triggerCalender=useSelector((state) => state.appointment.triggerCalendar);
    const [selected, setSelected] = useState(false);
    const [calendar, setCalendar] = useState(false);
    const [calIsOpen, setCalIsOpen] = useState(false);
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);
    const handleClick = (link) => {
        window.open(link, '_blank');
    };

    const handleOpen=(title)=>{
        setCalIsOpen(!calIsOpen);
        if(title===selected){
            setSelected(false);
        }
        else{
            setSelected(title)
        }
    }
    useEffect(() => {
        if(triggerCalender){
            setCalIsOpen(true)
        }
    }, [triggerCalender]);
    return (
        <div className="leadCardButtonOuterWrapper" style={{flex: '1'}}>
            {title==="Lead PDF" ?(
                 <div className="leadTopBarButton outlineQuilityActiveButton"><a href="#" onClick={()=>handleClick(leadsAlldata.pdf)} className="pdfLink">{title}</a></div>
            ): title==='Appointment' ? (
                <>
                    <div className="leadTopBarButton outlineQuilityActiveButton" onClick={()=>handleOpen(title)}>{title}</div>
                    <div className={`calendarWrapper ${calIsOpen ? 'openCal' : ''}`}>
                        {calIsOpen && (
                            <Calendar2 newEvent={newEvent} setApptSet={setApptSet} update={update} newAppt={newAppt} setNewAppt={setNewAppt} setIsOpen={setCalIsOpen} defaultCalendar={defaultCalendar} newEventPackage={newEventPackage} setEvent={setEvent}/>
                        )}
                    </div>
                </>
            ) :  title==='Qualifier' ? (
                    <div className={`leadTopBarButton outlineQuilityActiveButton ${qualifier ? 'activeLeadCardButton' : ''}`} onClick={()=>handleSetScripting(true)}>{title}</div>
            ) : title==="Schedule Call" ? (
                <>
                    <div className={`leadTopBarButton outlineQuilityActiveButton${selected===title ? 'focusButton' : ''}`} onClick={()=>setIsOpen(!isOpen)}>{title}</div>
                    <div className={`dialogBox ${isOpen ? 'openBox' : ''}`}>
                        <ScheduleCall />
                    </div>
                </>
            ) : title==="Attach File" ? (
                <>
                    <div className={`leadTopBarButton outlineQuilityActiveButton ${selected===title ? 'focusButton' : ''}`} onClick={()=>setIsOpen(!isOpen)}>{title}</div>
                    <div className={`dialogBox ${isOpen ? 'openBox' : ''}`} style={{overflow: 'auto'}}>
                        <AttachFile files={leadsAlldata.file_link} leadId={leadsAlldata.lead_id}/>
                    </div>
                </>
            ) : (
                <>
                    <div className={`leadTopBarButton outlineQuilityActiveButton ${selected===title ? 'focusButton' : ''}`} onClick={()=>handleOpen(title)}>{title}</div>
                    <div className={`dialogBox ${isOpen ? 'openBox' : ''}`}>
                    </div>
                </>
            )}
        </div>
    );

}

export default LeadTopBarButton;
